import rest from "@/utils/rest";
export default {
  Authentificate: (username, password) => {
    let formData2 = {
      username,
      password,
    };
    let link = "User/authenticate";
    return rest.channel(link, {
      body: JSON.stringify(formData2),
      method: "POST",
    });
  },
  CheckUser: (username) => {
    let formData1 = {
      username,
    };
    let link = "User/ResetPassword/CheckUser";
    return rest
      .channel(link, {
        body: JSON.stringify(formData1),
        method: "POST",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  ResetPassword: (username, otp, newpassword) => {
    let formData1 = {
      userName: username,
      otp: otp,
      newPassword: newpassword,
    };
    let link = "User/ResetPassword/Reset";
    return rest
      .channel(link, {
        body: JSON.stringify(formData1),
        method: "POST",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  GetRoleList: () => {
    let link = "User/GetRoleList";
    return rest
      .channel(link, {
        method: "GET",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
};
